import { render, staticRenderFns } from "./UploadTituloDetalhes.vue?vue&type=template&id=11a11d7c"
import script from "./UploadTituloDetalhes.vue?vue&type=script&lang=js"
export * from "./UploadTituloDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11a11d7c')) {
      api.createRecord('11a11d7c', component.options)
    } else {
      api.reload('11a11d7c', component.options)
    }
    module.hot.accept("./UploadTituloDetalhes.vue?vue&type=template&id=11a11d7c", function () {
      api.rerender('11a11d7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UploadTituloDetalhes.vue"
export default component.exports